export const TRIAGE_STATUS_CLOSED = 'Closed'
export const TRIAGE_STATUSES = [
  'New',
  'In progress',
  'Ins present',
  'Inelig hold',
  TRIAGE_STATUS_CLOSED,
]
